import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';

class AppHeader extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            AppHeaderClass: props.AppHeaderClass,
            AppHeaderLeft: props.AppHeaderLeft,
            AppHeaderLeftLink: props.AppHeaderLeftLink,
            AppHeaderTitle: props.AppHeaderTitle,
            AppHeaderRight: props.AppHeaderRight,
            AppHeaderRightLink: props.AppHeaderRightLink,
            AppHeaderSearch: props.AppHeaderSearch || '',
            redirect: false,
			search_text: '',
        }
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSearchClick = (e) => {

        e.preventDefault();
        var a = $("#search").hasClass("show");
        if (a) {
            $("#search").removeClass("show");
        }
        else {
            $("#search").addClass("show");
            $("#search .form-control").focus();
        }        
    };

	handleSubmit(event) {
		event.preventDefault();
		this.setState({ redirect: true });
		this.setState({ search_text: event.target.elements.search.value });

		event.target.elements.search.value = '';
	}

    render() { 
       //console.log(this.state);
	 
       if (this.state.redirect)
       {
           this.setState({ redirect: false });
           return <Redirect to={`/search/${this.state.search_text}`} />;
       }

       return (
            <div>
                <div className={this.state.AppHeaderClass}>
                    <div className="left">{this.state.AppHeaderLeft=='showLINK' && <Link to={this.state.AppHeaderLeftLink} className="headerButton goBack pl-0"><ion-icon name="chevron-back-outline"></ion-icon></Link> }</div>
                    <div className="pageTitle">
                        {this.state.AppHeaderSearch!='' &&
                            <div class="chip chip-outline search-chip">
                                <span class="chip-label"> {this.state.AppHeaderSearch} </span>
                                <Link to="/categories" class="chip-delete">
                                    <ion-icon name="close-circle" role="img" class="md hydrated" aria-label="close circle"></ion-icon>
                                </Link>
                            </div>
                        }
                        {this.state.AppHeaderSearch=='' && this.state.AppHeaderTitle}
                    </div>        
                    <div className="right">
                        { this.state.AppHeaderRightLink=='SEARCH' && <Link to="#" onClick={(e) => {this.handleSearchClick(e); }} className="headerButton toggle-searchbox"> <ion-icon name="search-outline"></ion-icon> </Link>}
                        { this.state.AppHeaderRightLink!='SEARCH' && this.state.AppHeaderRightLink!='' && <Link to={this.state.AppHeaderRightLink} className="headerButton text-secondary"> {this.state.AppHeaderRight} </Link>}
                        { this.state.AppHeaderRightLink=='' && this.state.AppHeaderRight }
                    </div>
                </div>
                <div id="search" className="appHeader">
                    <form className="search-form" ref={el => (this.form = el)} onSubmit={this.handleSubmit}>
                        <div className="form-group searchbox">
                            <input type="search" className="form-control" name="search" placeholder="Search..." minLength="3"/>
                            <i className="input-icon">
                                <ion-icon name="search-outline"></ion-icon>
                            </i> 
                            <Link to="#" className="ml-1 close toggle-searchbox" onClick={(e) => {this.handleSearchClick(e); }}>
                                <ion-icon name="close-circle"></ion-icon>
                            </Link>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}
      
export default AppHeader;


// WEBPACK FOOTER //
// ./src/components/AppHeader.js